import * as libphonenumber from 'libphonenumber-js';

export const PhoneValidate = (phone) => {
  phone = phone.replace(/[^0-9|^۰-۹]/g, '');
  phone = libphonenumber.parsePhoneNumber(phone, "IR").formatNational().replace(/[^0-9&^۰-۹]/g, '');

  const re = /^(\+98|0)?9\d{9}$/;
  let res = re.test(phone);
  if (res) {
    return {phone, valid: true};
  } else {
    return {phone, valid: false};
  }
};
